import { useTranslation } from '@rpi/i18n';

export const PasswordStrengthHook = (password: string) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });

  const checkStrength = () => {
    let strength = 0;

    if (password.length >= 8) {
      strength += 1;
    }
    if (password.match(/[a-zA-Z]+/)) {
      strength += 1;
    }
    if (password.match(/[0-9]+/)) {
      strength += 1;
    }
    if (password.match(/[^a-zA-Z0-9]/)) {
      strength += 1;
    }

    return strength;
  };

  const strength = checkStrength();

  const strengthText = () => {
    switch (strength) {
      case 1:
        return t('weak');
      case 2:
        return t('fair');
      case 3:
        return t('good');
      case 4:
        return t('strong');
      default:
        return '';
    }
  };

  const bgColor = () => {
    switch (strength) {
      case 2:
        return `bg-password-fair`;
      case 3:
        return `bg-password-good`;
      case 4:
        return `bg-password-strong`;
      default:
        return `bg-password-weak`;
    }
  };
  const textColor = () => {
    switch (strength) {
      case 2:
        return `text-password-fair`;
      case 3:
        return `text-password-good`;
      case 4:
        return `text-password-strong`;
      default:
        return `text-password-weak`;
    }
  };
  return { strength, strengthText, bgColor, textColor };
};
